import {
  CreateTagGroupInputSchema_,
  TagGroupSchema,
} from "@redotech/redo-model/support/tag-group-zod-schema";
import * as z from "zod";

export const createTagGroup = {
  name: "createTagGroup" as const,
  input: CreateTagGroupInputSchema_.extend({ tagIds: z.array(z.string()) }),
  output: z.object({ tagGroup: TagGroupSchema }),
};
